export var DocsBlockItemEntityType;
(function (DocsBlockItemEntityType) {
    /** Token entity */
    DocsBlockItemEntityType["token"] = "Token";
    /** Token group entity */
    DocsBlockItemEntityType["tokenGroup"] = "TokenGroup";
    /** Asset entity */
    DocsBlockItemEntityType["asset"] = "Asset";
    /** Asset group entity */
    DocsBlockItemEntityType["assetGroup"] = "AssetGroup";
    /** Component entity */
    DocsBlockItemEntityType["component"] = "Component";
    /** Component group entity */
    DocsBlockItemEntityType["componentGroup"] = "ComponentGroup";
})(DocsBlockItemEntityType || (DocsBlockItemEntityType = {}));
